import withComparisonResources from '../resources/withComparisonResources';

import ComparisonTable from './components/ComparisonTable';

const ComparisonTableContainer = withComparisonResources(ComparisonTable);
export { ComparisonTable, ComparisonTableContainer };
